// extracted by mini-css-extract-plugin
export default {"Paper":"Home_Paper__lly41","Logo":"Home_Logo__EASwS"};